import React, { useEffect, useState, useRef } from "react";
import { configSlideAbout } from "../../provider/dataconfig";
import styles from "../../styles/home.module.css";
import documentStyles from "../../styles/consultation/consultation.css";
import {
  itemsPresentation,
  politiquesContent,
  deberesContent,
} from "../../provider/dataconfig";
import Modal from "../../components/modal";
import { isMobile } from "react-device-detect";

const Documents = () => {
  // State Modal
  const [open, setOpen] = useState(false);
  const [itemModalSeleted, setItemContentModal] = useState(0);
  const [contentModal, setContentModal] = useState({});

  // Slide
  const swiperElRef = useRef(null);
  useEffect(() => {
    // listen for Swiper events using addEventListener
    swiperElRef.current.addEventListener("progress", (e) => {
      const [progress] = e.detail;
      console.log(progress);
    });

    swiperElRef.current.addEventListener("slidechange", (e) => {
      console.log("slide changed");
    });
  }, []);

  const handleClick = (title, content, index) => {
    // State Open
    setOpen(!open);
    // Set New index item selected
    setItemContentModal(index);
    // State content
    setContentModal({
      title,
      content,
    });
  };

  return (
    <>
      <div className={"ConsultationDocumentsContainer mb-5"}>
        <section className={styles.main_slide}>
          <swiper-container
            ref={swiperElRef}
            slides-per-view="1"
            navigation="true"
            pagination="true"
          >
            {configSlideAbout.map((slide) => (
              <swiper-slide>
                <div className={styles.wrapper_contain_slide}>
                  <img
                    className={styles.img_main_slide}
                    src={isMobile ? slide.imgMobile : slide.img}
                    alt={slide.title_img}
                  />
                  <span className={styles.title_slide}>{slide.title}</span>
                  <span className={styles.description_slide}>
                    {slide.description}
                  </span>
                </div>
              </swiper-slide>
            ))}
          </swiper-container>
        </section>
        <div className="container mt-5">
          <h1>Documentos de Consulta</h1>
          <div className="accordion mt-3" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse0"
                  aria-expanded="false"
                  aria-controls="collapse0"
                >
                  PROCEDIMIENTO CONFIDENCIALIDAD Y TRATAMIENTO DE LA INFORMACION
                </button>
              </h2>
              <div
                id="collapse0"
                className="accordion-collapse collapse "
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <iframe
                    src="/PDF/confidencialidad.pdf"
                    width="100%"
                    height="600px"
                    title="Procedimiento Confidencialidad"
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse1"
                  aria-expanded="false"
                  aria-controls="collapse1"
                >
                  REGLAMENTO USO DE CERTIFICADOS, LOGOTIPOS Y MARCAS
                </button>
              </h2>
              <div
                id="collapse1"
                className="accordion-collapse collapse "
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <iframe
                    src="/PDF/reglamentos_uso.pdf"
                    width="100%"
                    height="600px"
                    title="Reglamento Uso de Certificados"
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse2"
                  aria-expanded="false"
                  aria-controls="collapse2"
                >
                  DESCRIPCION DEL PROCESO DE CERTIFICACION
                </button>
              </h2>
              <div
                id="collapse2"
                className="accordion-collapse collapse "
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <iframe
                    src="/PDF/descripcion_proceso.pdf"
                    width="100%"
                    height="600px"
                    title="Descripción del Proceso de Certificación"
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse3"
                  aria-expanded="false"
                  aria-controls="collapse3"
                >
                  PROCEDIMIENTO SUSPENSIÓN, RETIRO O REDUCCIÓN DEL ALCANCE DE
                  CERTIFICACIÓN
                </button>
              </h2>
              <div
                id="collapse3"
                className="accordion-collapse collapse "
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <iframe
                    src="/PDF/procedimiento_suspension.pdf"
                    width="100%"
                    height="600px"
                    title="Procedimiento Suspensión"
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse4"
                  aria-expanded="false"
                  aria-controls="collapse4"
                >
                  PROCEDIMIENTO QUEJAS Y APELACIONES
                </button>
              </h2>
              <div
                id="collapse4"
                className="accordion-collapse collapse "
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <iframe
                    src="/PDF/procedimiento_quejas.pdf"
                    width="100%"
                    height="600px"
                    title="Procedimiento Quejas y Apelaciones"
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse5"
                  aria-expanded="false"
                  aria-controls="collapse5"
                >
                  REGLAMENTO DEL PROCESO DE EVALUACION Y CERTIFICACION
                </button>
              </h2>
              <div
                id="collapse5"
                className="accordion-collapse collapse "
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <iframe
                    src="/PDF/reglamentos_quejas.pdf"
                    width="100%"
                    height="600px"
                    title="Reglamento del Proceso de Evaluación"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Documents;
